import api from './api';

const scheduleService = {
    // Create a new schedule with goals
    createSchedule: async (workspaceId, scheduleData) => {
        const response = await api.post('/schedules', {
            ...scheduleData,
            workspaceId
        });
        return response.data;
    },

    // Get all schedules for workspace
    getSchedules: async (workspaceId, params = {}) => {
        const response = await api.get('/schedules', {
            params: { workspaceId, ...params }
        });
        return response.data;
    },

    // Get single schedule with goals
    getSchedule: async (scheduleId, workspaceId) => {
        const response = await api.get(`/schedules/${scheduleId}`, {
            params: { workspaceId }
        });
        return response.data;
    },

    // Update schedule
    updateSchedule: async (scheduleId, workspaceId, updates) => {
        const response = await api.put(`/schedules/${scheduleId}`, {
            ...updates,
            workspaceId
        });
        return response.data;
    },

    // Delete schedule
    deleteSchedule: async (scheduleId, workspaceId) => {
        const response = await api.delete(`/schedules/${scheduleId}`, {
            params: { workspaceId }
        });
        return response.data;
    },

    // Pause schedule
    pauseSchedule: async (scheduleId, workspaceId) => {
        const response = await api.post(`/schedules/${scheduleId}/pause`, {
            workspaceId
        });
        return response.data;
    },

    // Resume schedule
    resumeSchedule: async (scheduleId, workspaceId) => {
        const response = await api.post(`/schedules/${scheduleId}/resume`, {
            workspaceId
        });
        return response.data;
    },

    // Duplicate schedule
    duplicateSchedule: async (scheduleId, workspaceId) => {
        const response = await api.post(`/schedules/${scheduleId}/duplicate`, {
            workspaceId
        });
        return response.data;
    },

    // Execute schedule now
    executeScheduleNow: async (scheduleId, workspaceId) => {
        const response = await api.post(`/schedules/${scheduleId}/execute`, {
            workspaceId
        });
        return response.data;
    },

    // Get schedule execution history
    getScheduleExecutions: async (scheduleId, params = {}) => {
        const response = await api.get(`/schedules/${scheduleId}/executions`, {
            params
        });
        return response.data;
    },

    // Get upcoming schedules
    getUpcomingSchedules: async (workspaceId, limit = 10) => {
        const response = await api.get('/schedules/upcoming', {
            params: { workspaceId, limit }
        });
        return response.data;
    }
};

export default scheduleService;
